import React from "react";
import { createRoot } from "react-dom/client";
import { BrowserRouter } from "react-router-dom";
import App from "App";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";

import { MaterialUIControllerProvider } from "context";

import { PublicClientApplication } from "@azure/msal-browser";
import { MsalProvider } from "@azure/msal-react";
import { msalConfig } from "./authConfig";

import backgroundImage from "assets/images/SeaScape.png";

const container = document.getElementById("app");
const root = createRoot(container);

const msalInstance = new PublicClientApplication(msalConfig);

async function init() {
  await msalInstance.initialize();

  // Handle redirect result
  const response = await msalInstance.handleRedirectPromise();

  if (response !== null && response.account) {
    msalInstance.setActiveAccount(response.account);
  } else {
    const accounts = msalInstance.getAllAccounts();
    if (accounts.length === 1) {
      msalInstance.setActiveAccount(accounts[0]);
    }
  }

  // Render after MSAL is fully ready
  root.render(
    <BrowserRouter>
      <MaterialUIControllerProvider>
        <MsalProvider instance={msalInstance}>
          <div
            style={{
              minHeight: "100vh",
              backgroundImage: `url(${backgroundImage})`,
              backgroundSize: "cover",
              backgroundPosition: "center",
              backgroundRepeat: "no-repeat",
            }}
          >
            <App />
          </div>
        </MsalProvider>
      </MaterialUIControllerProvider>
    </BrowserRouter>
  );
}

init().catch((error) => {
  console.error("MSAL initialization error:", error);
});
